import { Component, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { LoadingBarService } from '@ngx-loading-bar/core';
import { map, delay, withLatestFrom } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { ApiCartService } from './shared/api-services/cart.service';
import { ApiProductService } from './shared/api-services/product.service';
import { PixelService } from 'ngx-pixel';
import { Meta, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  host: {
    '(window:consent.given)':'onConsentGiven($event)',
    '(window:consent.rejected)':'onConsentRejected($event)',
  }
})
export class AppComponent {
  
  // For Progressbar
  loaders = this.loader.progress$.pipe(
    delay(1000),
    withLatestFrom(this.loader.progress$),
    map(v => v[1]),
  );
  
  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private loader: LoadingBarService, translate: TranslateService,
    private apiCartService: ApiCartService, private apiProductService: ApiProductService,
    private pixel: PixelService, private titleService: Title, private metaService: Meta
  ) {
    if (isPlatformBrowser(this.platformId)) {
      translate.setDefaultLang('en');
      translate.addLangs(['en', 'fr']);
    }
    document.documentElement.style.setProperty('--theme-deafult', '#0fb3db');
    this.apiCartService.getCart().subscribe(() => {});
    this.apiProductService.getProducts().subscribe(() => {});

    this.metaService.addTags([
      { name: 'keywords', content: 'out wear, outgravitywear, gravity clothing, abbigliamento poc mtb, endura, abbigliamento mtb, bici, bici elettrica, bicicletta, bici gravel, bici da corsa, bici da strada, bici mountain bike, abbigliamento bici, abbigliamento mtb uomo, abbigliamento ciclismo invernale, abbigliamento mtb invernale, abbigliamento bici invernale, abbigliamento mtb estivo, abbigliamento mtb uomo invernale, abbigliamento mtb enduro, abbigliamento invernale bici da corsa, abbigliamento mtb invernale uomo, abbigliamento ciclismo online, mtb tech, abbigliamento bici, abbigliamento bici uomo, abbigliamento bici donna, abbigliamento bici da corsa, abbigliamento bici gravel, abbigliamento bici mtb, abbigliamento bici corsa, abbigliamento bici corsa donna, abbigliamento bici corsa estivo, abbigliamento da bici, abbigliamento bici enduro, abbigliamento bici estivo, abbigliamento bici estate, abbigliamento estivo bici corsa, abbigliamento estivo bici da strada, abbigliamento bici uomo estivo, abbigliamento e bici, negozi abbigliamento bici, abbigliamento bici fox, abbigliamento mtb freeride, fox abbigliamento bici, abbigliamento bici gravel invernale, abbigliamento hero mtb, hot stuff abbigliamento bici, abbigliamento bici invernale uomo, abbigliamento bici inverno, abbigliamento bici invernale donna, abbigliamento ciclismo invernale, bici abbigliamento, abbigliamento mtb cross, abbigliamento bici online, abbigliamento bici trek, abbigliamento bike wear, abbigliamento mtb xc, abbigliamento x ciclismo, abbigliamento x mtb, abbigliamento x bici mtb, abbigliamento invernale x bici da corsa, abbigliamento downhill, abbigliamento enduro' },
    ]);

    this.titleService.setTitle('Out Wear');
  }

  onConsentGiven() {
    this.pixel.initialize();
  }

  onConsentRejected() {
    this.pixel.remove();
  }
}
